import Collapse from './collapse';

export default Collapse;
export type * from './types';
